import APIServicesRegistry from '@lib/api-services/APIServicesRegistry';
import Modal from '@lib/components/common/Modal';
import React from 'react';
import Filter from '../../model/index-table/Filter';
import Button from '../common/Button';
import Dropdown from '../common/DropdownReact';
import ExpandableFloatingDropdown from '../common/ExpandableFloatingDropdown';
import LinkButton from '../common/LinkButton';
import Loader from '../common/Loader';
import IconDelete from '../icons/IconDelete';
import IconExport from '../icons/IconExport';
import IconExportCSV from '../icons/IconExportCSV';
import IconExportPDF from '../icons/IconExportPDF';
import IconExportXLS from '../icons/IconExportXLS';
import saveBlobAsFile from '../utils/saveBlobAsFile';
import * as Helper from './IndexHelpers';
import IndexPageContext from './IndexPageContext';
import IndexTable from './IndexTable';
import IndexTableFiltersPanel from './filterComponents/IndexTableFiltersPanel';
import IndexTablePager from './IndexTablePager';
import {reaction} from 'mobx';

export class IndexPage extends React.Component {
    indexApiService = null;
    editApiService = null;
    busy = false
    canIgnoreResponse = false
    responsesToIgnore = 0
    lastFormModelRequestTime = 0
    formModelUpdateTimeout = -1;
    _isMounted = false;

    static defaultProps = {
        tableLoadingLoader: false
    }

    constructor(props) {
        super(props)
        this.tableRef = React.createRef();
        this.filterRef = React.createRef();
        this.responsiveTableContainer = React.createRef();
        this.responsiveTableContainerTopScroll = React.createRef();
        this.responsiveTableContainerTopScrollContent = React.createRef();
        this.state = {
            deleteModalIsOpen: false,
            currentPage: props.paging.page - 1,
            currentPageSize: props.paging.pageSize,
            totalPages: props.paging.totalPages,
            order: [],
            filter: this.props.filter,
            filterData: {},
            filters: {},
            checkedRowsNum: 0,
            isExporting: false,
            isLoading: false,
            renderTrigger: 0,
            results: this.props.results,
            manuallyChangedRows: {},
            columns: props.columns,
        }

        //this.onRowCheckboxToggled = this.onRowCheckboxToggled.bind(this);
        this.createStateForPostIndexData = this.createStateForPostIndexData.bind(this);
        this.mergeFilterWithFilterDataFilter = this.mergeFilterWithFilterDataFilter.bind(this);
        scheduleAtDocumentReady(() => {
            //this.topScroll();
            this.atDocumentReady();
        });
    }

    topScroll = () => {
        if (this.responsiveTableContainer.current) {
            if (this.responsiveTableContainer.current.scrollWidth <= this.responsiveTableContainer.current.clientWidth) {
                this.responsiveTableContainerTopScroll.current.style.display = 'none';
            }

            this.responsiveTableContainerTopScrollContent.current.style.minWidth = `${this.responsiveTableContainer.current.scrollWidth}px`;
            this.responsiveTableContainer.current.onscroll = () => {
                this.responsiveTableContainerTopScroll.current.scrollLeft = this.responsiveTableContainer.current.scrollLeft;
            }

            this.responsiveTableContainerTopScroll.current.onscroll = () => {
                this.responsiveTableContainer.current.scrollLeft = this.responsiveTableContainerTopScroll.current.scrollLeft;
            }
        }
    }

    atDocumentReady = () => {
        if (this.props.editApiService) {
            this.editApiService = APIServicesRegistry.getService(this.props.editApiService);
        }

        if (this.props.indexApiService) {
            this.indexApiService = APIServicesRegistry.getService(this.props.indexApiService);
        }

        if (this._isMounted) {
            this.setState({renderTrigger: Math.random()})
        }
    }

    componentDidMount() {
        this._isMounted = true;
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    onRemoveClick() {
        var ids = []
        for (let [k, v] of Object.entries(this.state.manuallyChangedRows)) {
            if (v) {
                ids.push(parseInt(k))
            }
        }

        this.setState({isLoading: true})
        this.editApiService.deleteBatch(ids).then(() => {
            var filtered = this.state.results.filter(x => !ids.includes(x.id))
            this.setState({
                results: filtered,
                deleteModalIsOpen: false,
                isLoading: false
            })
        })
    }

    onRemoveRowClick = id => {
        var filtered = this.state.results.filter(x => x.id !== id)
        this.setState({
            results: filtered
        })
    }

    onPagerNavigateClick = page => {
        this.setState({
            isLoading: true
        })

        this.indexApiService.indexPage({
            columns: this.state.columns.map(x => x.slug),
            filter: (this.state.filterData || {}).filter,
            order: this.state.order,
            page: page + 1,
            pageSize: this.state.currentPageSize
        }).then(response => {

            let result = response.data.data.map(x => x);
            for (var i = 0; i < result.length; i++) {
                let isHidden = result[i].hidden === "True";
                result[i].hidden = isHidden;
            }
            this.setState({
                results: response.data.data,
                currentPage: page,
                isLoading: false
            });
        })
    }

    buildScalarFilter(query) {
        let val1 = query.value.value1 || "";
        let val2 = query.value.value2 || "";

        let operation = "range";

        if (val2 === "") {
            operation = "gte";
        }

        if (val1 === "") {
            operation = "lte";
            val1 = val2;
            val2 = "";
        }

        return {
            operation: operation,
            value1: val1,
            value2: val2
        }
    }

    buildMultiSelectFilter(query, filter) {
        let value = query.value;


        if (filter === undefined) {
            return {
                operation: 'in',
                values: [value]
            };

        } else {
            filter.operation = 'in';
            filter.values.push(value);
            return filter;
        }


    }

    onReloadCall = () => {
        let filterData = this.state.filterData;
        this.postIndexData(filterData);
    }

    onFiltersChange = (queries) => {
        let filters = {}
        queries.forEach(query => {
            if (query.type === Filter.Type.ScalarDate || query.type === Filter.Type.Scalar) {
                filters[query.slug] = this.buildScalarFilter(query)
            } else if (query.type === Filter.Type.Collection) {
                filters[query.slug] = this.buildMultiSelectFilter(query, filters[query.slug]);
                // filters[query.slug] = {
                //     operation: 'in',
                //     values: [query.value]
                // }
            } else if (query.type == Filter.Type.Select) {
                filters[query.slug] = query.value
            } else {
                filters[query.slug] = {
                    operation: 'contains',
                    value: query.value
                }
            }
        })

        var allFilters = {...filters, ...this.state.filter.hiddenFilters, ...this.getFilterDataForGroupButton()}

        let filterData = {
            ...this.buildIndexAPIRequestModel(),
            filter: allFilters
        };

        this.setState({filterData: filterData});

        this.postIndexData(filterData);

    }

    postIndexData = (filterData) => {
        this.setState({
            isLoading: true
        }, () => {
            this.indexApiService.indexPage(filterData).then(response => {
                var state = this.createStateForPostIndexData(response);
                this.setState({
                    ...state
                })
            })
        })
    }

    mergeFilterWithFilterDataFilter(response) {
        let filterDataFilterTemp = {...this.state.filterData.filter};

        if(response.data.filter && response.data.filter.viewFilters){
            response.data.filter.viewFilters.forEach(f => {
                if (filterDataFilterTemp[f.meta.slug]) {
                    filterDataFilterTemp[f.meta.slug] = f.model;
                }
            });
        }

        return filterDataFilterTemp;
    }

    createStateForPostIndexData(response) {
        let resultInfo = response.data.resultInfo;
        return {
            filter: response.data.filter || this.state.filter,
            filterData: {...this.state.filterData, filter: this.mergeFilterWithFilterDataFilter(response)},
            results: response.data.data,
            isLoading: false,
            currentPage: resultInfo.page - 1,
            currentPageSize: resultInfo.pageSize,
            totalPages: this.calculateTotalPages(resultInfo.pageSize, resultInfo.resultCount)
        }
    }

    calculateTotalPages(pageSize, totalResults) {
        if (totalResults === 0)
            return 1;
        return Math.ceil(totalResults / pageSize)
    }

    onSortChange = (column, direction) => {
        let order = [{slug: column.slug, direction: direction}];
        this.setState({isLoading: true});
        var request = this.buildIndexAPIRequestModel();
        request.filter = this.state.filterData.filter;
        request.order = order;

        this.indexApiService.indexPage(request).then(response => {
            this.setState({
                results: response.data.data,
                order: order,
                isLoading: false
            });
        })
    }

    onRootCheckboxToggled = manuallyChangedRows => {
        this.setState({
            manuallyChangedRows: manuallyChangedRows
        }, () => {
            this.onRowCheckboxToggledPost();

            if (this.props.onRootCheckboxToggled) {
                this.props.onRootCheckboxToggled()
            }
        })
    }

    onRowCheckboxToggled = manuallyChangedRows => {
        this.setState({
            manuallyChangedRows: manuallyChangedRows
        }, () => {
            this.onRowCheckboxToggledPost();

            if (this.props.onRowCheckboxToggled) {
                this.props.onRowCheckboxToggled(manuallyChangedRows)
            }
        })
    }

    onRowCheckboxToggledPost = () => {
        /* virtual */
    }

    onMassExportItemClick = item => {
        if (this.state.isExporting) {
            return;
        }

        this.setState({isExporting: true});

        var request = {
            ...this.buildIndexAPIRequestModel(),
            selectedIds: this.getSelectedRowIds()
        }
        this.indexApiService.export(item.label, request).then(response => {
            saveBlobAsFile(response)
            this.setState({isExporting: false})
        }).catch(e => {
            this.setState({isExporting: false})
        });
    }

    buildIndexAPIRequestModel() {
        return {
            columns: this.state.columns.map(x => x.slug),
            filter: this.buildFilterRequestModel(),
            order: this.state.order,
            page: this.state.currentPage + 1,
            pageSize: this.state.currentPageSize
        }
    }

    buildFilterRequestModel() {
        return (this.state.filterData || {}).filter
    }

    getExportOptions() {
        if (!this.props.options.exports || this.state.results.length === 0) {
            return null;
        }

        const icons = {
            'csv': IconExportCSV,
            'pdf': IconExportPDF,
            'xls': IconExportXLS,
            'xlsx': IconExportXLS
        };

        return this.props.options.exports.map(x => ({
            id: x.slug,
            label: x.name,
            icon: icons[x.name.toLowerCase()]
        }))
    }

    renderTitle = () => {
        if (this.props.titleComponentClass) {
            return this.props.titleComponentClass();
        }

        return (
            <React.Fragment>
                <h3 className="page-body-title">{this.props.title}</h3>
                {this.props.title && <div className="page-body-title-separator"></div>}
            </React.Fragment>
        )
    }

    renderTable = () => {
        const Table = this.props.tableComponentClass || IndexTable;
        return (
            <Table
                ref={this.tableRef}
                page={this}
                results={this.state.results}
                options={this.props.options}
                orderOptions={this.props.orderOptions}
                columns={this.state.columns}
                onSortChange={this.onSortChange}
                onRemoveRowClick={this.onRemoveRowClick}
                onRootCheckboxToggled={this.onRootCheckboxToggled}
                onRowCheckboxToggled={this.onRowCheckboxToggled}
                multiSelectRows={this.props.multiSelectRows}
                onReloadCall={this.onReloadCall}
            />
        )
    }

    renderGroupButton = () => {
        return <React.Fragment></React.Fragment>;
    }

    getFilterDataForGroupButton = () => {
        return {};
    }

    getIndexTableFilterPanelComponent = () =>
        this.props.filterPanelComponentClass ? this.props.filterPanelComponentClass : IndexTableFiltersPanel;

    render() {
        return (
            <IndexPageContext.Provider value={{editAPIService: this.editApiService}}>
                <div className="page-body-container page-container">
                    {this.renderHeader()}
                    {this.renderContent()}
                </div>
            </IndexPageContext.Provider>
        )
    }

    renderFilterPanel = () => {
        const IndexTableFiltersPanelComponent = this.getIndexTableFilterPanelComponent();
        return <IndexTableFiltersPanelComponent
            ref={this.filterRef}
            filter={this.state.filter.viewFilters.filter(x => x.meta.visible)}
            onFiltersChange={this.onFiltersChange}
            isLoading={this.state.isLoading}
        />
    }

    renderHeader = () => (
        <div className="page-body-titlebar">
            <div className="flex-center-v">
                {this.renderTitle()}
                {this.renderTitleButtons()}
            </div>

            <div className="page-body-action-buttons">
                <div className="desktop-only">
                    {this.props.options.headerButtons.map((button, index) => (
                        <LinkButton key={index} href={button.url} size={Button.Size.Default}>{button.name}</LinkButton>
                    ))}
                </div>

                <div className="index-page-floaters mobile-only">
                    <ExpandableFloatingDropdown>
                        {this.props.options.headerButtons.map((button, index) => (
                            <ExpandableFloatingDropdown.Item
                                key={index}
                                onClick={() => window.location.href = button.url}
                            >
                                {button.name}
                            </ExpandableFloatingDropdown.Item>
                        ))}
                    </ExpandableFloatingDropdown>
                </div>
            </div>
        </div>
    )

    renderContent = () => (
        <div className={`page-body-content ${this.state.isLoading ? 'is-loading' : ''}`}>
            <div>
                {this.renderFilterPanel()}
            </div>
            <div>
                {this.renderGroupButton()}
            </div>
            <div className="index-table-container" style={this.props.tableLoadingLoader ? {position: 'relative'} : {}}>
                {this.state.isLoading && (
                    <Loader fillContainer={true}/>
                )}

                {this.state.results.length === 0 ? (
                    <div className="index-page-no-results-message">
                        {__('No results.')}
                    </div>
                ) : (
                    <React.Fragment>
                        <div>
                            {/* <div className="top-scroll" ref={this.responsiveTableContainerTopScroll}>
                                        <div className="top-scroll-content" ref={this.responsiveTableContainerTopScrollContent}>
                                            <img />
                                        </div>
                                    </div> */}
                            <div className="responsive-table-container" ref={this.responsiveTableContainer}>
                                {this.renderTable()}
                                <div className="index-table-footer-actions-container">
                                    <div className="index-table-footer-actions">
                                        {this.renderFooterActionButtons()}
                                    </div>
                                    {this.indexTablePagerVisible() && (
                                        <div>
                                            <IndexTablePager
                                                currentPage={this.state.currentPage}
                                                pages={this.state.totalPages}
                                                onNavigateToPageClick={this.onPagerNavigateClick}
                                            />
                                        </div>
                                    )}
                                    <div style={{width: "90.47px"}}></div>
                                </div>
                            </div>
                        </div>


                    </React.Fragment>
                )}
            </div>
        </div>
    )

    renderFooterActionButtons() {
        return (
            this.props.options.hasCheckboxColumn && (
                <React.Fragment>
                    <Button
                        theme={Button.Theme.BorderOnly}
                        disabled={this.areFooterActionButtonsDisabled()}
                        onClick={() => this.setState({deleteModalIsOpen: true})}
                        icon={IconDelete}
                    >
                        {__('Delete')}
                    </Button>

                    <Modal isOpen={this.state.deleteModalIsOpen}
                           onClose={() => this.setState({deleteModalIsOpen: false})} closeTimeoutMS={125}>
                        <Modal.Header>{__('Remove')}</Modal.Header>
                        <Modal.Body>{__('Do you want to remove these objects?')}</Modal.Body>
                        <Modal.Footer>
                            <Button theme={Button.Theme.BorderOnly}
                                    onClick={() => this.setState({deleteModalIsOpen: false})}>{__('Cancel')}</Button>
                            <Button theme={Button.Theme.BorderOnly}
                                    onClick={() => this.onRemoveClick()}>{__('Remove')}</Button>
                        </Modal.Footer>
                    </Modal>
                </React.Fragment>
            )
        )
    }

    renderTitleButtons = () => (
        <React.Fragment>
            {this.renderExportDropdown()}
        </React.Fragment>
    )

    renderExportDropdown = () => (
        this.getExportOptions() && <div className="mass-export-dropdown">
            <Dropdown
                items={this.getExportOptions()}
                caption={__(this.state.isExporting ? 'Exporting...' : 'Export as...')}
                onItemClick={this.onMassExportItemClick}
                icon={IconExport}
                disabled={this.state.isExporting}
            />
        </div>
    )

    indexTablePagerVisible = () => this.props.indexTablePagerVisible === undefined ? true : this.props.indexTablePagerVisible;

    areFooterActionButtonsDisabled = () => this.getSelectedRowIds().length === 0

    getSelectedRowIds = () => Object.entries(this.state.manuallyChangedRows || {}).filter(([k, v]) => v === true).map(([k]) => k);
}

export default IndexPage